import axios from 'axios'
import config from '../utils/config'
const ROOM_BOOKING_ENDPOINT = config.api[process.env.NODE_ENV].meetingRoom
/**
|--------------------------------------------------
| [GET] List Meeting Room
|--------------------------------------------------
*/
export const getListMeetingRoom = () =>
  axios
    .get(`${ROOM_BOOKING_ENDPOINT}/meeting-room/list/`)
    .then(response => response.data)

/**
|--------------------------------------------------
| [GET] List Meeting Room For Admin
|--------------------------------------------------
*/
export const getListMeetingRoomAdmin = (page, limit) =>
  axios
    .get(`${ROOM_BOOKING_ENDPOINT}/meeting-room/page/`, {
      params: { page, limit }
    })
    .then(response => response.data)

/**
|--------------------------------------------------
| [GET] Detail Meeting Room
| @param {number} roomId - Meeting Room ID
|--------------------------------------------------
*/
const defaultDetailMeetingRoomParams = 0
export const getDetailMeetingRoom = (roomId = defaultDetailMeetingRoomParams) =>
  axios
    .get(`${ROOM_BOOKING_ENDPOINT}/meeting-room/${roomId}`)
    .then(response => response.data)

/**
|--------------------------------------------------
| [PUT] Update Meeting Room
|--------------------------------------------------
*/
export const updateMeetingRoom = (roomId, roomData) =>
  axios
    .put(`${ROOM_BOOKING_ENDPOINT}/meeting-room/${roomId}`, roomData)
    .then(response => response.data)

/**
|--------------------------------------------------
| [POST] Create Meeting Room
|--------------------------------------------------
*/
export const createMeetingRoom = room =>
  axios
    .post(`${ROOM_BOOKING_ENDPOINT}/meeting-room/`, room)
    .then(response => response.data)

/**
|--------------------------------------------------
| [GET] List Booking
| @param {string} from - Date string (DD/MM/YYYY)
| @param {number} meetingRoomID
|--------------------------------------------------
*/
const defaultListBookingParams = {
  from: '',
  to: '',
  meetingRoomID: 0
}
export const getListBooking = (params = defaultListBookingParams) =>
  axios
    .get(`${ROOM_BOOKING_ENDPOINT}/booking/list/`, { params: { ...params } })
    .then(response => response.data)

/**
|--------------------------------------------------
| [GET] Detail Booking
| @param {number} bookingId
|--------------------------------------------------
*/
const defaultDetailBookingParams = 0
export const getDetailBooking = (bookingId = defaultDetailBookingParams) =>
  axios
    .get(`${ROOM_BOOKING_ENDPOINT}/booking/${bookingId}`)
    .then(response => response.data)

/**
|--------------------------------------------------
| [POST] Create Booking
| @param {number} meetingRoomID
| @param {string} meetingDay - DD/MM/YYYY
| @param {string} untilDate - DD/MM/YYYY
| @param {number} startTime
| @param {number} endTime
| @param {string} description
| @param {number} type - 0:none, 1:day, 2:week, 3:month
| @param {number} interval
| @param {array} attendees - {[ID], Name, Email}
|--------------------------------------------------
*/
const defaultCreateBookingParams = {
  meetingRoomID: 0,
  meetingDay: '',
  untilDate: '',
  startTime: 0,
  endTime: 0,
  description: '',
  type: 0,
  interval: 0,
  attendees: []
}
export const createBooking = (params = defaultCreateBookingParams) =>
  axios
    .post(`${ROOM_BOOKING_ENDPOINT}/booking/`, params)
    .then(response => response.data)

/**
|--------------------------------------------------
| [PUT] Update Booking
| @param {number} meetingRoomID
| @param {number} startTime
| @param {number} endTime
| @param {string} meetingDay - DD/MM/YYYY
| @param {string} description
|--------------------------------------------------
*/
const defaultUpdateBookingParams = {
  startTime: 0,
  endTime: 0,
  description: '',
  meetingDay: '',
  attendees: []
}
export const updateBooking = (bookingID, params = defaultUpdateBookingParams) =>
  axios
    .put(`${ROOM_BOOKING_ENDPOINT}/booking/${bookingID}`, params)
    .then(response => response.data)

/**
|--------------------------------------------------
| [DELETE] Delete Booking
|--------------------------------------------------
*/
export const deleteBooking = (bookingID, reasons) =>
  axios
    .delete(
      `${ROOM_BOOKING_ENDPOINT}/booking/${bookingID}?reasons=${reasons}`,
      {
        reasons: reasons
      }
    )
    .then(response => response.data)

/**
|--------------------------------------------------
| [DELETE] Delete Booking Repeat
|--------------------------------------------------
*/
export const deleteBookingRepeat = (SeriesID, reasons) =>
  axios
    .delete(
      `${ROOM_BOOKING_ENDPOINT}/bookingRepeat/${SeriesID}?reasons=${reasons}`
    )
    .then(response => response.data)



// WEBPACK FOOTER //
// ./src/api/meetingRoomBooking.js